import React from 'react';
import { CondensedLarge, Gutter, SectionHeader, Well } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

export type TalentAboutProps = {
  candidate: Pick<
    Candidate,
    'candidateSummary' | 'calculatedFirstName' | 'calculatedDisplayName'
  >;
};

export const TalentAbout = ({ candidate }: TalentAboutProps) => {
  return (
    <Well name="TALENT_ABOUT" background="light blue">
      <SectionHeader name="TALENT_ABOUT_HEADER">
        About {candidate.calculatedFirstName || candidate.calculatedDisplayName}
      </SectionHeader>
      <Gutter bottom="8px" />
      <CondensedLarge name="TALENT_ABOUT_SUMMARY">
        {candidate.candidateSummary}
      </CondensedLarge>
    </Well>
  );
};
